import { render } from "./editSellRequest.vue?vue&type=template&id=32982450&scoped=true"
import script from "./editSellRequest.vue?vue&type=script&lang=js"
export * from "./editSellRequest.vue?vue&type=script&lang=js"

import "./editSellRequest.vue?vue&type=style&index=0&id=32982450&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32982450"]])

export default __exports__